module.exports = __webpack_public_path__ + "static/img/pictureA.dfb29fe4.png";